export const REACT_APP_BASE_URL_BE = `https://${window.location.host.split('.').shift()}.widget.insent.ai/`;
export const REACT_APP_BASE_URL_FE = `https://${window.location.host.split('.').shift()}.widget.insent.ai/`;